<template>
  <el-drawer
    title="事项指标管理"
    :visible.sync="dialogVisible"
    direction="rtl"
    :before-close="handleClose"
    :close-on-press-escape="false"
    :wrapperClosable="false"
    size="560px"
    append-to-body
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="top"
        :model="formInline"
        class="demo-form-inline"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          label="指标名称(考评内容)"
          style="width: 100%;"
          prop="zbmc"
        >
          <el-input
            v-model="formInline.zbmc"
            placeholder="请输入指标名称(考评内容)"
          ></el-input>
        </el-form-item>
        <el-form-item label="分值/权重" style="width: 100%;">
          <el-input
            v-model="formInline.fzqz"
            placeholder="请输入分值/权重"
          ></el-input>
        </el-form-item>
        <el-form-item label="考核对象(指标类型)" style="width:100%;">
          <el-input
            v-model="formInline.khdx"
            placeholder="请输入考核对象(指标类型)"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="指标选项(评分标准)"
          style="width:100%;"
          prop="zbxs"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.zbxs"
            placeholder="请输入指标选项(评分标准)"
            show-word-limit
            style="white-space: pre-wrap;"
            ref="zbxs"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="指标说明" style="width: 100%;">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.zbsm"
            placeholder="请输入指标说明"
            show-word-limit
            style="white-space: pre-wrap;"
            ref="zbsm"
            maxlength="200"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        zbmc: "",
        fzqz: "",
        khdx: "",
        zbxs: "",
        zbsm: "",
        isAdd: true,
        index: ""
      },
      loading: false,
      rules: {
        zbmc: [
          {
            required: true,
            message: "请输入指标名称(考评内容)",
            trigger: "blur"
          }
        ],
        zbxs: [
          {
            required: true,
            message: "请输入指标选项(评分标准)",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    if (!this.curItem.isAdd) {
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
    }
  },
  methods: {
    async onSubmit() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      this.$emit("updateData", this.formInline);
      this.handleClose();
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/#el-drawer__title {
  height: 64px;
  margin-bottom: 0;
  padding: 24px 16px 16px 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #494c4f;
}
.container-dialog {
  padding: 14px 24px 24px;
}
/deep/.el-form-item {
  width: calc(50% - 12px);
  margin-bottom: 20px;
  margin-right: 8px;
  .el-form-item__label {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    line-height: 1;
  }
  .el-select {
    width: 100%;
  }
  .el-input__inner {
    height: 40px;
    width: 100%;
  }
}
/deep/.demo-drawer__footer {
  width: 100%;
  padding: 24px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/indexDrawer.vue